"use strict";

/**
 * @classdesc
 * Setzt die Sichtbarkeit auf den angegebenen Staus für alle Layer.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action.layer
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} options.map Referenz auf die Karte
 * @param {bool} options.visible Sichtbarkeit ja/nein
 */
gc.gis.action.layer.SetVisibilityAllLayer = function(options)
{
	gc.gis.action.GCAbstractAction.call( this );

	/**
	 * @inheritdoc
	 */
	this.func = this.setVisible;
	/**
	 * @inheritdoc
	 */
	this.args = [options.map, options.visible];
};
gc.gis.action.layer.SetVisibilityAllLayer.prototype = Object.create(gc.gis.action.GCAbstractAction.prototype);

/**
 * Setzt die Sichtbarkeit aller Layer der Karte auf den angebenen Wert.
 *
 * @public
 * @param {gc.gis.map.GCMapView} map Referenz auf die Karte
 * @param {bool} visible Sichtbarkeit ja/nein
 * @see gc.gis.action.GCAbstractAction#execute
 */
gc.gis.action.layer.SetVisibilityAllLayer.prototype.setVisible = function(map, visible)
{
	var layers = map.getLayersRecursive();

	for (var i=0; i<layers.length; i++)
	{
		layers[i].setVisible(visible);
	}
};
